import { render, staticRenderFns } from "./AppFocusLock.vue?vue&type=template&id=2a6e9bf0&lang=pug&"
import script from "./AppFocusLock.vue?vue&type=script&lang=js&"
export * from "./AppFocusLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports